import { defineCustomElement } from 'vue'
import ScrollToTop from '$vueCommon/components/ScrollToTop.vue'

const ScrollToTopElement = defineCustomElement(ScrollToTop, {
    shadowRoot: false
});

export { ScrollToTopElement }

customElements.define('scroll-to-top', ScrollToTopElement);
